import * as breakpoints from "../../breakpoints";
import * as colors from "../../constants/colors";
import * as languages from "../../constants/languages";
import { browserHistory } from "react-router";
import { completeClassUrl, getClass, startClass } from "../../api/class";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../../constants/strings";
import { handleUnknownError } from "../../lib/errorHandler";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import * as util from "../../lib/util";

const styles = StyleSheet.create({
	buttonContainer: {
		textAlign: "center",
	},
	button: {
		border: `3px solid ${colors.gold2}`,
		color: colors.gold2,
		backgroundColor: colors.white,
		borderRadius: 20,
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 18,
		paddingRight: 18,
		marginTop: 24,
		marginBottom: 24,
		lineHeight: 2,
		fontSize: 15,
		fontFamily: "freight-sans-pro",
		fontWeight: "bold",
		[breakpoints.mobileOnly]: {
			marginBottom: 56,
			marginTop: 56,
		},
	},
	container: {
		paddingBottom: 60,
		paddingTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		// textAlign: "center",
	},
	contentContainer: {
		maxWidth: 960,
		margin: "auto",
	},
	readerAnswerInput: {
		marginTop: 12,
		borderRadius: 2,
		borderWidth: 1,
		borderColor: colors.gray,
		paddingTop: 8,
		paddingBottom: 8,
		display: "flex",
		flex: 1,
		flexBasis: "auto",
		flexShrink: 0,
		flexGrow: 1,
		maxWidth: 400,
		fontSize: 14,
	},
	readerQuestionContainer: {
		display: "flex",
		flex: 1,
		flexDirection: "column",
	},
});

export default class AccessibleClassPage extends PureComponent {
	static propTypes = {
		classId: PropTypes.string.isRequired,
		email: PropTypes.string,
		language: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = {
			class: {},
			readerAnswer: "",
		};
	}

	componentDidMount() {
		this._loadClass(this.props.classId);
	}

	_loadClass = classId => {
		getClass(classId, this.props.language === languages.es ? languages.es : null)
			.then(data => {
				startClass(
					classId,
					this.props.language === languages.es ? languages.es : null,
				).catch(err => {
					if (err.response && err.response.status === 401) {
						// NOTE: This is a stop-gap solution. Need to build real refresh interceptor
						util.deleteCookies();
						window.location.assign("/login");
					}
				});
				this.setState({
					class: data,
				});
			})
			.catch(err => {
				handleUnknownError(err);
				if (err.response && err.response.status === 404) {
					browserHistory.push({
						pathname: "/catalog",
						query: { language: this.props.language },
					});
				}
			});
	};

	_setReaderAnswer = text => {
		this.setState({
			readerAnswer: text,
		});
	};

	render() {
		return (
			<div className={css(styles.container)}>
				<div
					dangerouslySetInnerHTML={{ __html: this.state.class.readerHTML }}
					className={css(styles.contentContainer)}
				/>
				<div className={css([styles.contentContainer, styles.readerQuestionContainer])}>
					<label htmlFor="certificate-question-input">
						{this.state.class.readerQuestion}
					</label>
					<input
						className={css(styles.readerAnswerInput)}
						type="text"
						onChange={e => this._setReaderAnswer(e.target.value)}
						value={this.state.readerAnswer}
						id="certificate-question-input"
					/>
				</div>
				<div className={css(styles.buttonContainer)}>
					<a
						href={completeClassUrl(
							this.props.classId,
							this.props.email,
							this.state.readerAnswer,
							this.props.language,
						)}
					>
						<button className={css(styles.button)}>
							{this.strings.COMPLETE_CLASS}
						</button>
					</a>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/AccessibleClassPage.js